"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_data_table_component_1 = require("react-data-table-component");
const _variables_scss_1 = __importDefault(require("../../scss/_variables.scss"));
const DataTableTheme_1 = __importDefault(require("../enums/DataTableTheme"));
(0, react_data_table_component_1.createTheme)(DataTableTheme_1.default.main, {
    text: {
        primary: _variables_scss_1.default.gray_500,
    },
    background: {
        default: 'transparent',
    },
    divider: {
        default: 'transparent',
    },
    sortFocus: {
        default: _variables_scss_1.default.gray_400,
    },
});
(0, react_data_table_component_1.createTheme)(DataTableTheme_1.default.sub, {
    text: {
        primary: _variables_scss_1.default.gray_500,
    },
    background: {
        default: 'transparent',
    },
    divider: {
        default: _variables_scss_1.default.gray_200,
    },
    sortFocus: {
        default: _variables_scss_1.default.secondary,
    },
});
